import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
    CardWrapperProps,
    CarouselWrapperProps,
    SliderProps
} from './Carousel.types';

export const CarouselWrapper = styled('div')<CarouselWrapperProps>(
    ({ peekingSlides, theme: { spacing } }) => css`
        position: relative;
        padding: 0;
        margin: ${peekingSlides ? '0 -1rem' : '0 -1rem 0 0'};
        ${CardWrapper} {
            padding-left: ${peekingSlides ? spacing['16px'] : 0};
            padding-right: ${peekingSlides ? 0 : spacing['16px']};
            &:last-child {
                margin-right: ${peekingSlides ? spacing['16px'] : 0};
            }
        }
    `
);

export const ButtonGroup = styled.div(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: flex-end;
        column-gap: ${spacing['8px']};
    `
);

export const SlideWrapper = styled('div')<SliderProps>(
    ({ shouldScroll, theme: { spacing } }) => css`
        position: relative;
        height: auto;
        width: 100%;
        display: inline-block;
        white-space: nowrap;
        overflow-x: ${shouldScroll ? 'visible' : 'scroll'};
        vertical-align: top;
        scrollbar-width: none;
        margin-bottom: ${spacing['24px']};
        &::-webkit-scrollbar {
            display: none;
        }
    `
);

const iterateBreakpoints = ({
    breakpoints,
    numChildren
}: Pick<CardWrapperProps, 'breakpoints' | 'numChildren'>) => {
    let result = '';

    const total = (numCards: number) =>
        numChildren <= numCards ? numChildren : numCards;

    breakpoints.forEach(
        (bp) =>
            (result += `@media only screen and (min-width: ${bp.size}px) {
                            width: ${(1 / total(bp.numCards)) * 100}%;
                         }`)
    );

    return result;
};

export const CardWrapper = styled('li')<CardWrapperProps>(
    ({ breakpoints, numCards, numChildren }) => css`
        width: ${(1 / numCards) * 100}%;
        white-space: normal;
        min-height: 1px;
        margin: 0;
        padding: 0;
        display: inline-block;
        vertical-align: top;

        ${iterateBreakpoints({ breakpoints, numChildren })};
    `
);

export const Slider = styled('ul')`
    margin: 0;
    padding: 0;
`;

export const FooterWrapper = styled('div')(
    ({ theme: { breakpoints } }) => css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1rem;

        @media only screen and (min-width: ${breakpoints[1]}px) {
            padding: 0;
            padding-right: 1rem;
        }
    `
);
